import yup from "src/validators/yup.Module";

export interface TributacaoCfopCadastroDto {
  id: number;
  tributacaoId: number;
  cfop: string;
  tipoParametro: number;
  tipoParametroDescricao: string;
  parametroValor: number;
  categoriaNome: string;
  mensagemId?: number | null;
}

export interface TributacaoCfopCadastroImpostoDto {
  id: number;
  tributacaoCFOPId: number;
  tipoImposto: number;
  tipoImpostoDescricao: string;
  cst: number;
  aliquotaSimples: number;
  classificacoesTributarias?: string | null;
  inclusaoUsuarioId: number;
  inclusaoDataHora: string;
  alteracaoUsuarioId: number;
  alteracaoDataHora: string;
}

export const TributacaoCfopCadastroSchema = yup.object().shape({
  cfop: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
  mensagemId: yup
    .number()
    .nullable()
    .notRequired()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? null
        : Number(originalValue)
    ),
});

